import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=0d8e08a0&"
import script from "./calendar.vue?vue&type=script&lang=ts&"
export * from "./calendar.vue?vue&type=script&lang=ts&"
import style0 from "./calendar.vue?vue&type=style&index=0&id=0d8e08a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports